(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collection-directory]').forEach(function(directory) {
    var search = directory.querySelector('[data-directory-search]');
    var type = directory.querySelector('[data-directory-type]');
    var cards = Array.from(directory.querySelectorAll('[data-directory-card]'));
    var count = directory.querySelector('[data-directory-count]');
    var empty = directory.querySelector('[data-directory-empty]');
    function filterCards() {
      var query = search.value.trim().toLowerCase();
      var selectedType = type.value;
      var visible = 0;
      cards.forEach(function(card) {
        var matchesSearch = !query || card.dataset.title.indexOf(query) !== -1;
        var cardTypes = (card.dataset.types || 'other').split(' ');
        var matchesType = selectedType === 'all' || cardTypes.indexOf(selectedType) !== -1;
        var show = matchesSearch && matchesType;
        card.hidden = !show;
        if (show) visible += 1;
      });
      count.textContent = visible + ' / ' + cards.length;
      if (empty) empty.hidden = visible !== 0;
    }
    search.addEventListener('input', filterCards);
    type.addEventListener('change', filterCards);
    filterCards();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  var cartUpdateTimer;

  function scheduleCartUpdate(input) {
    var form = input.closest('[data-cart-form]');
    if (!form) return;
    window.clearTimeout(cartUpdateTimer);
    cartUpdateTimer = window.setTimeout(function() {
      form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('[data-cart-quantity]').forEach(function(button) {
        button.disabled = true;
      });
      form.requestSubmit();
    }, 350);
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-cart-quantity]');
    if (!button) return;
    var control = button.closest('.cart-quantity');
    var input = control && control.querySelector('input[type="number"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 0;
    var minimum = parseInt(input.min, 10) || 0;
    input.value = button.dataset.cartQuantity === 'increase' ? current + 1 : Math.max(minimum, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-cart-form] .cart-quantity input[type="number"]')) return;
    scheduleCartUpdate(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-browser]').forEach(function(browser) {
    var panel = browser.querySelector('.collection-filters');
    var backdrop = browser.querySelector('.collection-filter-backdrop');
    var opener = browser.querySelector('[data-filter-open]');
    if (!panel || !opener) return;
    function setOpen(open) {
      panel.classList.toggle('is-open', open);
      backdrop.classList.toggle('is-open', open);
      opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('filters-open', open);
    }
    opener.addEventListener('click', function() { setOpen(true); });
    browser.querySelectorAll('[data-filter-close]').forEach(function(button) { button.addEventListener('click', function() { setOpen(false); }); });
    document.addEventListener('keydown', function(event) { if (event.key === 'Escape') setOpen(false); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-quantity-action]');
    if (!button) return;
    var control = button.closest('.quantity-control');
    var input = control && control.querySelector('input[type="number"]');
    if (!input) return;
    var value = parseInt(input.value) || 1;
    if (button.getAttribute('data-quantity-action') === 'increase') {
      input.value = value + 1;
    } else if (value > 1) {
      input.value = value - 1;
    }
  });

  window.openLightbox = function(element) {
    var img = element.querySelector('img');
    if (!img) return;
    document.getElementById('LightboxImage').src = img.src || img.currentSrc;
    document.getElementById('ProductLightbox').classList.add('active');
    document.body.style.overflow = 'hidden';
  };
  
  window.closeLightbox = function() {
    document.getElementById('ProductLightbox').classList.remove('active');
    document.body.style.overflow = '';
  };

  document.addEventListener("DOMContentLoaded", function() {
    var desc = document.querySelector('.product-buy__description');
    if (!desc) return;

    var children = Array.from(desc.children);
    var details = null;
    
    // Normalize spaces in textContent to avoid issues with &nbsp;
    function normalize(str) {
      return str.replace(/[\u00a0\s]+/g, ' ').trim().toLowerCase();
    }

    // 1. Attempt to find "Key Features" block
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      var text = normalize(el.textContent);
      
      if (text.includes('key feature') || text.includes('features:') || text === 'features') {
        details = document.createElement('details');
        var summary = document.createElement('summary');
        
        if (text.length < 80 && !el.querySelector('br')) {
          // It's a short standalone heading
          summary.textContent = el.textContent.replace(/:/g, '').trim() || 'Key Features';
          details.appendChild(summary);
          
          var contentDiv = document.createElement('div');
          // Move everything after the heading into the accordion
          while (el.nextSibling) {
            contentDiv.appendChild(el.nextSibling);
          }
          details.appendChild(contentDiv);
          el.style.display = 'none';
          
        } else {
          // It's a combined paragraph (heading + features separated by <br>)
          var htmlParts = el.innerHTML.split(/<br\s*\/?>/i);
          if (htmlParts.length > 1) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlParts[0];
            summary.textContent = tempDiv.textContent.replace(/:/g, '').trim() || 'Key Features';
            details.appendChild(summary);
            
            var contentP = document.createElement('p');
            contentP.innerHTML = htmlParts.slice(1).join('<br>');
            details.appendChild(contentP);
          } else {
            summary.textContent = 'Key Features';
            details.appendChild(summary);
            details.appendChild(el.cloneNode(true));
          }
          el.style.display = 'none';
        }
        
        desc.parentNode.insertBefore(details, desc.nextSibling);
        break; // Stop looking after we process the features
      }
    }
    
    // Fallback: If no paragraph matched but there is a <ul>, wrap the <ul>
    if (!details) {
      var ul = desc.querySelector('ul');
      if (ul) {
        var prev = ul.previousElementSibling;
        var summaryText = 'Key Features';
        if (prev && normalize(prev.textContent).includes('feature')) {
          summaryText = prev.textContent.replace(/:/g, '').trim();
          prev.style.display = 'none';
        }
        details = document.createElement('details');
        var summary = document.createElement('summary');
        summary.textContent = summaryText;
        details.appendChild(summary);
        details.appendChild(ul);
        desc.parentNode.insertBefore(details, desc.nextSibling);
      }
    }

    // 2. Group short specification paragraphs into a grid
    // Get paragraphs again as the DOM might have changed
    var remainingPs = Array.from(desc.children);
    var grid = document.createElement('div');
    grid.className = 'spec-grid';
    
    var gridAdded = false;
    remainingPs.forEach(function(p) {
      if ((p.tagName === 'P' || p.tagName === 'DIV') && p.textContent.includes(':') && p.textContent.length < 80 && !p.querySelector('img')) {
        p.style.marginBottom = '0';
        if (!gridAdded) {
          p.parentNode.insertBefore(grid, p);
          gridAdded = true;
        }
        grid.appendChild(p);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.seo-tab-btn');
  const panes = document.querySelectorAll('.seo-tab-pane');
  
  if (!tabs.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Remove active from all
      tabs.forEach(t => t.classList.remove('active', 'aria-selected'));
      panes.forEach(p => p.classList.remove('active'));
      
      // Add active to clicked
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
      
      const targetId = this.getAttribute('data-target');
      document.getElementById(targetId).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
